<template>
  <div class="app-content content">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="DCC Transactions Details"
              bc1="App"
              bc2="DCC Transactions"
              bc3="List"
          ></Breadcrumb>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section class="app-user-list">
          <div class="card">
            <h5 class="card-header">Filters</h5>
            <div class="d-flex align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-6 user_plan mb-1">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
                      <label>Merchant</label>
                      <SearchSelect
                          v-model="selectedMerchant"
                          url="v1/get-merchants"
                          ref="merchantSearchSelect"
                          :filterParams="{ flag: 'all' }"
                          :customLabelFn="customNameForMultiselect"
                          placeholder="Search Merchant..."
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan mb-1">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
                      <label>Store</label>
                      <InfiniteSelect
                          api-url="v1/get-store"
                          ref="storeInfiniteSelect"
                          :request-params="storeRequestParams"
                          :formatter="(obj) => obj.name + '/' + obj.code"
                          key-field="id"
                          @selectedFullObj="(item) => selectedStore = item"
                          placeholder-text="Select a store..."
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan mb-1">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
<!--                      <label>From Date</label>-->
                      <date-picker
                          v-model="fromDate"
                          :disabledDate="disableFutureDates"
                          valueType="format"
                          :lang="lang"
                          name="fromDate"
                          placeholder="choose start date"
                          :clearable="false"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan mb-1">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
<!--                      <label>To Date</label>-->
                      <date-picker
                          v-model="toDate"
                          :disabledDate="disableFutureDates"
                          valueType="format"
                          :lang="lang"
                          name="toDate"
                          placeholder="choose end date"
                          :clearable="false"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-12 user_status">
                <button type="button" class="btn btn-primary" @click="onSubmitFilters">Search</button>
                <button type="button" class="ml-1 btn btn-danger" @click="clear">Clear</button>
              </div>
            </div>
          </div>
          <div class="card">
            <div>
              <CommonTable
                  :url="url"
                  :tableHeaderValues="tableHeaderValues"
                  :actions="actions"
                  :deleteActions="deleteActions"
                  :mutedData="mutedData"
                  :storageKey="storageKey"
                  :externalTotalRecord="externalTotalRecord"
                  :filteredData="filteredData"
                  :exportData="exportData"
                  :hidePdfExportButton="true"
                  :showPerPage="true"
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteSelect from "@/components/common/InfiniteSelect.vue";
import SearchSelect from "@/components/common/SearchSelect.vue";
import DatePicker from "vue2-datepicker";

export default {
  components: {
    InfiniteSelect,
    SearchSelect,
    DatePicker
  },
  mounted() {
    localStorage.setItem("url", "v1/dcc-transactions-details");
    this.checkDataInStore('v1/dcc-transactions-details');
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    
    return {
      exportData: {
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'dcc-transactions-details',
          }

          let filter = this.filteredData

          requestData = {
            ...requestData,
            ...filter
          }


          this.downloadReport(requestData,this.url)
        }
      },
      selectedMerchant: null,
      selectedStore: null,
      fromDate: formattedDate,
      toDate: formattedDate,
      tableHeaderValues: [
        {
          title: 'Store Code',
          valueKey: 'store_code'
        },
        {
          title: 'Name',
          valueKey: 'name'
        },
        {
          title: 'Opted Count',
          valueKey: 'opted_count'
        },
        {
          title: 'Non Opted Count',
          valueKey: 'non_opted_count'
        },
        {
          title: 'Total Count',
          valueKey: 'total_count'
        },
        {
          title: 'Opted Volume',
          valueKey: 'opted_volume',
          alter: (value) => {
            if (value) {
              return (parseFloat(value) / 100).toFixed(2);
            }
            return '-';
          }
        },
        {
          title: 'Non Opted Volume',
          valueKey: 'non_opted_volume',
          alter: (value) => {
            if (value) {
              return (parseFloat(value) / 100).toFixed(2);
            }
            return '-';
          }
        },
        {
          title: 'Total Volume',
          valueKey: 'total_volume',
          alter: (value) => {
            if (value) {
              return (parseFloat(value) / 100).toFixed(2);
            }
            return '-';
          }
        },
        {
          title: 'DCC Markup Percentage',
          valueKey: 'dcc_markup_percentage',
          alter: (value) => {
            if (value) {
              return (parseFloat(value) / 100).toFixed(2);
            }
            return '-';
          }
        },
        {
          title: 'DCC Rebate Percentage',
          valueKey: 'dcc_rebate_percentage',
          alter: (value) => {
            if (value) {
              return (parseFloat(value) / 100).toFixed(2);
            }
            return '-';
          }
        },
        {
          title: 'DCC Markup Value',
          valueKey: 'dcc_markup_value',
          alter: (value) => {
            if (value) {
              return (parseFloat(value) / 100).toFixed(2);
            }
            return '-';
          }
        },
        {
          title: 'DCC Rebate Value',
          valueKey: 'dcc_rebate_value',
          alter: (value) => {
            if (value) {
              return (parseFloat(value) / 100).toFixed(2);
            }
            return '-';
          }
        },
        {
          title: 'Net DCC Value',
          valueKey: 'net_dcc_value',
          alter: (value) => {
            if (value) {
              return (parseFloat(value) / 100).toFixed(2);
            }
            return '-';
          }
        }
      ],
      actions: [],
      url: "v1/dcc-transactions-details",
      storageKey: "dcc-transactions-details",
      mutedData: [],
      deleteActions: [],
      externalTotalRecord: "",
      filteredData: {
        fromDate: formattedDate,
        toDate: formattedDate
      },
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      }
    }
  },
  computed: {
    storeRequestParams() {
      const params = {
      };
      if (this.selectedMerchant && this.selectedMerchant.id) {
        params.userId = this.selectedMerchant.id;
      }
      return params;
    }
  },
  watch: {
    selectedMerchant(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedStore = null;
        this.$nextTick(() => {
          if (this.$refs.storeInfiniteSelect) {
            this.$refs.storeInfiniteSelect.clearSearch();
          }
        });
      }
    }
  },
  methods: {
    customNameForMultiselect({ email, first_name, business_name }) {
      const nameToUse = business_name === null || business_name === '' ? first_name : business_name;
      return `${email}/${nameToUse}`;
    },
    onSubmitFilters() {
      let filterData = {};

      // if (this.selectedMerchant && this.selectedMerchant.id) {
      //   filterData.merchant_id = this.selectedMerchant.id;
      // }

      if (this.selectedStore && this.selectedStore.id) {
        filterData.storeId = this.selectedStore.id;
      }

      filterData.fromDate = this.fromDate;
      filterData.toDate = this.toDate;

      this.filteredData = filterData;
    },
    clear() {
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0];
      
      this.selectedMerchant = null;
      this.selectedStore = null;
      this.fromDate = formattedDate;
      this.toDate = formattedDate;
      if (this.$refs.merchantSearchSelect) {
        this.$refs.merchantSearchSelect.reset();
      }
      this.$refs.storeInfiniteSelect.clearSearch();
      this.filteredData = {
        fromDate: this.fromDate,
        toDate: this.toDate
      };
    }
  }
}
</script>

<style scoped>
.table-scroll-y {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
</style>
